import classnames from 'classnames';
import React from 'react';

import css from './defaultIconStyles.css';

export const IconCircleCheckmarkFilled = ({
    width = '12',
    height = '12',
    className = '',
    ...rest
}) => (
    <svg
        width={width}
        height={height}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 12 12"
        className={classnames(css.main, className)}
        {...rest}
    >
        <g fill="none" fillRule="evenodd">
            <ellipse
                cx="6"
                cy="5.625"
                rx="5.25"
                ry="4.125"
                className={css.colored2}
            />
            <path
                className={css.colored}
                d="M6,0 C9.31125,0 12,2.68875 12,6 C12,9.31125 9.31125,12 6,12 C2.68875,12 0,9.31125 0,6 C0,2.68875 2.68875,0 6,0 Z M8.16375,4.0665 C8.27025,4.07475 8.3715,4.10025 8.46675,4.14975 C8.529,4.18275 8.58675,4.224 8.63775,4.27275 C8.83575,4.46175 8.91525,4.75125 8.8425,5.01525 C8.811,5.12925 8.75175,5.2305 8.6745,5.31975 C7.78425,6.25275 6.87225,7.164 5.94,8.05425 C5.8785,8.1075 5.8125,8.15325 5.7375,8.18625 C5.54625,8.271 5.3235,8.271 5.13225,8.18625 C5.05725,8.15325 4.99125,8.1075 4.92975,8.05425 C4.40175,7.5495 3.88425,7.0335 3.38025,6.50475 C3.303,6.4155 3.24375,6.31425 3.21225,6.1995 C3.1935,6.132 3.1845,6.0615 3.18525,5.991 C3.18825,5.70525 3.36,5.43975 3.6195,5.31975 C3.705,5.28 3.79725,5.25675 3.891,5.2515 C3.98475,5.2455 4.07925,5.25825 4.1685,5.2875 C4.28175,5.32425 4.37925,5.388 4.4655,5.46975 L5.43525,6.4395 C6.16125,5.71275 6.8715,4.9695 7.61475,4.26075 C7.64175,4.2375 7.64175,4.2375 7.66875,4.21575 C7.70775,4.188 7.74675,4.16325 7.78875,4.14225 C7.87425,4.10025 7.96425,4.07775 8.058,4.068 C8.094,4.06575 8.1285,4.065 8.16375,4.0665 Z"
            />
        </g>
    </svg>
);

export default IconCircleCheckmarkFilled;
